var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"surgos"},[_c('h1',{staticClass:"title"},[_vm._v("Orvosi ellátásra van szükségük, kérjük, támogasd őket!")]),_c('AnimalList',{attrs:{"animals":_vm.animalsNeedHelp}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }